module.exports = __webpack_public_path__ + "static/scale-model-of-haunted-knoxville-ghost-tours-in-knoxville-tennessee-e13ad63e77d717076aaf4920c2a0f993.png";